var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottery-popup',{attrs:{"showPrize":_vm.showPrize,"lotteryResult":_vm.lotteryResult,"prizePicture":_vm.prizePicture},on:{"close":_vm.changeShowPrize,"gotoLink":_vm.gotoLink,"clickConfirm":_vm.clickConfirm}})}
var staticRenderFns = []

export { render, staticRenderFns }